import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import { store, persistor } from './app/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { AbilityProvider } from './context/Ability';
import { HelmetProvider } from 'react-helmet-async';
import { ExpandedProvider } from './features/Gnn/contexts/ExpandedContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    {/* <HelmetProvider> */}
    <ThemeProvider>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ExpandedProvider>
              <AbilityProvider>
                <App />
              </AbilityProvider>
          </ExpandedProvider>
        </PersistGate>
      </Provider>
    </ThemeProvider>
    {/* </HelmetProvider> */}
  </React.Fragment>
);
